import { List, Set, Record } from 'immutable'

export const Calendar = Record({
  id: undefined,
  name: undefined,
  description: undefined,
})

export const AvailabilitySlotTime = Record({
  hour: 0,
  minutes: 0,
})

export const AvailabilitySlot = Record({
  dayOfWeek: undefined,
  startTime: AvailabilitySlotTime(),
  endTime: AvailabilitySlotTime(),
})

export const Meeting = Record({
  allowNewAppointments: true,
  allowMeetingManagement: false,
  availability: List(),
  bufferTime: 0,
  name: '',
  slug: '',
  oldSlug: '', // does not get saved in BE...
  duration: 15,
  inviteDescription: '',
  location: '',
  minimumNoticeTime: 30,
  timezone: undefined,
})

export const MeetingState = Record({
  connected: false,
  scopes: [],
  googleAuthed: false,
  googleAuthedError: false,
  microsoftAuthed: false,
  isTokenRevoked: false,
  microsoftCalendarAdminError: false,
  fetchMicrosoftAdminConsentStatus: undefined,
  fetchMicrosoftGlobalCalendarStatus: undefined,

  meetingTypes: List(),
  meetingTypesStatus: undefined,

  calendlyMeetingTypes: List(),
  calendlyMeetingTypesStatus: undefined,

  calendar: Calendar(),
  calendars: List(),

  meeting: Meeting(),
  meetingStatus: undefined,

  agentIdsWithConnectedCalendarsStatus: undefined,
  agentIdsWithConnectedCalendars: Set(),

  calendarStatusFetchStatus: undefined,
  googleCalendarsFetchStatus: undefined,
  microsoftCalendarsFetchStatus: undefined,

  microsoftCalendarAdminManaged: undefined,
  microsoftCalendarAdminIds: Set(),
  shareRoutedCalendarLoading: false
})

export const makeMeeting = response => {
  return Meeting({
    ...response,
    ...response.meetingTemplate,
    availability: List(
      response.availability.map(slot => {
        return AvailabilitySlot({
          dayOfWeek: slot.dayOfWeek,
          startTime: AvailabilitySlotTime({
            hour: slot.startTimeHour,
            minutes: slot.startTimeMinutes,
          }),
          endTime: AvailabilitySlotTime({
            hour: slot.endTimeHour,
            minutes: slot.endTimeMinutes,
          }),
        })
      })
    ),
  })
}

export const makeMeetingTypes = response => {
  return _.map(response, (meetingType, slug) => {
    return makeMeeting({ ...meetingType, slug })
  })
}

const convertCalendlyMeeting = calendlyMeeting => {
  const { name, duration, slug, location, description } = calendlyMeeting.attributes
  return Meeting({ name, duration, slug, location, description })
}

export const processCalendlyMeetings = calendlyMeetings => {
  return _.map(calendlyMeetings, calendlyMeeting => {
    return convertCalendlyMeeting(calendlyMeeting)
  })
}

export const defaultNewMeetingType = Meeting({
  name: '',
  allowNewAppointments: true,
  allowMeetingManagement: true,
  duration: 60,
  minimumNoticeTime: 0,
  bufferTime: 0,
  timezone: 'America/New_York',
  availability: List([
    AvailabilitySlot({
      dayOfWeek: 'WEEKDAYS',
      startTime: AvailabilitySlotTime({
        hour: 9,
        minutes: 0,
      }),
      endTime: AvailabilitySlotTime({
        hour: 17,
        minutes: 0,
      }),
    }),
  ]),
})

export const defaultProfileAccountSettings = Meeting({
  name: 'New Meeting',
  allowNewAppointments: true,
  allowMeetingManagement: true,
  duration: 60,
  minimumNoticeTime: 0,
  bufferTime: 0,
  timezone: 'America/New_York',
  availability: List([
    AvailabilitySlot({
      dayOfWeek: 'WEEKDAYS',
      startTime: AvailabilitySlotTime({
        hour: 9,
        minutes: 0,
      }),
      endTime: AvailabilitySlotTime({
        hour: 17,
        minutes: 0,
      }),
    }),
  ]),
})



// WEBPACK FOOTER //
// ./src/scripts/app/modules/meetings/models.js